'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteSubjectView', ['$controller', '$compile', 'NotesQueryManagementService', 'WorkPeriodStore', 'PositionsStore', 'UsersStore', '$q', 'TimeService', function($controller, $compile, NotesQueryManagementService, WorkPeriodStore, PositionsStore, UsersStore, $q, TimeService) {
      return {
        template: '',
        restrict: 'A',
        scope: {
          managementId: '@',
          verb: '@'
        },
        link: function(scope, elem) {
          var baseCtrl = $controller('BaseQuerySubscriptionCtrl', {$scope: scope});

          scope.state = {
            managementId: scope.managementId,
            verb: scope.verb,
            q: null,
            objCache: null
          };

          function updateCache() {
            var q = scope.state.q;

            var deferred = $q.defer();

            if (q.obj == 'WorkPeriod' && q.obj_id && (!scope.objCache || !scope.objCache.obj ||
                scope.objCache.type != 'WorkPeriod' || scope.objCache.obj.id != q.obj_id)) {
              WorkPeriodStore.getRecordById(q.obj_id)
                .then(function(wp) {
                  scope.objCache = {
                    type: 'WorkPeriod',
                    obj: wp
                  };
                  deferred.resolve();
                }, function() {
                  deferred.reject();
                });
            } else if (q.obj == 'Position' && q.obj_id && (!scope.objCache || !scope.objCache.obj || scope.objCache.type != 'Position' || scope.objCache.obj.id != q.obj_id)) {
              PositionsStore.getRecordById(q.obj_id)
                .then(function(position) {
                  scope.objCache = {
                    type: 'Position',
                    obj: position
                  };

                  deferred.resolve();
                }, function() {
                  deferred.reject();
                });
            } else if (q.obj == 'User' && q.obj_id && (!scope.objCache || !scope.objCache.obj || scope.objCache.type != 'User' || scope.objCache.obj.id != q.obj_id)) {
              UsersStore.getRecordById(q.obj_id)
                .then(function(user) {
                  scope.objCache = {
                    type: 'User',
                    obj: user
                  };

                  deferred.resolve();
                }, function() {
                  deferred.reject();
                });
            } else {
              deferred.resolve();
            }

            return deferred.promise;
          }

          function render(currentQuery) {
            scope.state.q = currentQuery;
            var q = scope.state.q;

            updateCache()
              .then(function() {
                var res = '';
                if (q.obj == 'date') {
                  var startAndEndAreSameDate = q.dates.start.format('MM/DD') === moment(q.dates.end).subtract(12, 'hours').format('MM/DD');

                  if (startAndEndAreSameDate) {
                    var nowInStoreTime = TimeService.getNowInStoreTime();
                    var todaysTwix = TimeService.getDayTwixFromDate(nowInStoreTime);
                    var tomorrowsTwix = TimeService.getDayTwixFromDate(moment(todaysTwix.start).add(36, 'hours'));
                    var yesterdaysTwix = TimeService.getDayTwixFromDate(moment(todaysTwix.start).subtract(12, 'hours'));

                    res += '<span sa-note-modify-context action="changeDay|-1"><i class="modify-context-click sa-icon-back sa-icon-1-2x"></i></span>';

                    if (todaysTwix.start.isSame(q.dates.start, 'seconds')) {
                      res += '<span>Today\'s Notes (' + q.dates.start.format('ddd, MMM Do') + ')</span>';
                    } else if (tomorrowsTwix.start.isSame(q.dates.start, 'seconds')) {
                      res += '<span>Tomorrow\'s Notes (' + q.dates.start.format('ddd, MMM Do') + ')</span>';
                    } else if (yesterdaysTwix.start.isSame(q.dates.start, 'seconds')) {
                      res += '<span>Yesterday\'s Notes (' + q.dates.start.format('ddd, MMM Do') + ')</span>';
                    } else {
                      res += '<span>Notes on ' + q.dates.start.format('ddd, MMM Do') + '</span>';
                    }
                  } else {
                    res += '<span>Notes on ' + q.dates.start.format('ddd, MMM Do') + ' thru ' + moment(q.dates.end).subract(12, 'hours').format('ddd, MMM Do') + '</span>';
                  }
                    res += '<span sa-note-modify-context action="changeDay|1"><i class="modify-context-click sa-icon-forward sa-icon-1-2x"></i></span>';
                } else if (q.obj == 'WorkPeriod') {
                  var obj = scope.objCache.obj;
                  var min = TimeService.minimalIntervalTimeFormat(moment(obj.start_time).twix(moment(obj.end_time)), undefined, 'ddd, MMM D');

                  res = '<span>Notes for</span>' + min.strings.interval;
                } else if (q.obj == 'Position') {
                  var obj = scope.objCache.obj;
                  if (q.obj_id) {
                    if (q.dates && q.dates.start && q.dates.end) {
                      res = '<span>Notes on ' + obj.name + '(' + q.dates.start.format('ddd, MMM Do') + ' thru ' + moment(q.dates.end).subract(12, 'hours').format('ddd, MMM Do') + ')</span>';
                    } else {
                      res = '<span>Notes on ' + obj.name + '</span>';
                    }
                  } else {
                    if (q.dates && q.dates.start && q.dates.end) {
                      res = '<span>Notes on Position ' + '(' + q.dates.start.format('ddd, MMM Do') + ' thru ' + moment(q.dates.end).subract(12, 'hours').format('ddd, MMM Do') + ')</span>';
                    } else {
                      res = '<span>Notes on Position</span>';
                    }

                  }
                } else if (q.obj == 'User') {
                  var obj = scope.objCache.obj;
                  if (q.obj_id) {
                    if (q.dates && q.dates.start && q.dates.end) {
                      res = '<span>Notes on ' + obj.name + '(' + q.dates.start.format('ddd, MMM Do') + ' thru ' + moment(q.dates.end).subract(12, 'hours').format('ddd, MMM Do') + ')</span>';
                    } else {
                      res = '<span>Notes on ' + obj.name + '</span>';
                    }
                  } else {
                    if (q.dates && q.dates.start && q.dates.end) {
                      res = '<span>Notes on Employees ' + '(' + q.dates.start.format('ddd, MMM Do') + ' thru ' + moment(q.dates.end).subract(12, 'hours').format('ddd, MMM Do') + ')</span>';
                    } else {
                      res = '<span>Notes on Employees</span>';
                    }
                  }

                } else {
                  res = '';
                }

                res = '<div class="sa-note-subject-view">' + res + '</div>';

                $(elem).html($compile(res)(scope));
              });
          }

          // Base ctrl
          baseCtrl.initialize('NoteSubjectView', scope.managementId);
          baseCtrl.setRenderCallback(render);
          baseCtrl.updateMyself();

          scope.$on('$destroy', function() {
            baseCtrl.uninitialize();
            baseCtrl = undefined;
          });
        }
      };
    }]);
